import React from 'react'
import PrimaryButton from '../../../../components/PrimaryButton'

class SearchButton extends React.Component {

    constructor() {
        super()
        this.state = {
            startDateTime: new Date(),
            totalRuntimeSeconds: 0
        }
    }

    setTotalRuntimeSeconds(runtimeSeconds) {
        this.setState((totalRuntimeSeconds) => { return { totalRuntimeSeconds: runtimeSeconds } })
    }

    setStartTimeState(newStartDateTime) {
        this.setState((previousState) => { return { startDateTime: newStartDateTime } })
    }

    calculateElapsedRuntimeSeconds() {
        let currentDateTime = new Date()
        let timeDifferenceMilliseconds = currentDateTime - this.state.startDateTime
        let elapsedSeconds = timeDifferenceMilliseconds / 1000;
        return elapsedSeconds
    }

    calculatePercentageComplete(elapsedSeconds) {
        let percentComplete = (elapsedSeconds * 100) / this.state.totalRuntimeSeconds
        if (percentComplete > 100) { // can happen if UI runs slightly longer than lambda on really short times
            percentComplete = 100
        }
        let intPercentComplete = parseInt(percentComplete, 10)
        return intPercentComplete
    }

    handleSkeletonSearch(tieupAssociativeArray, resultsHandler, updateProgressFunction) {

        let bodyText = JSON.stringify(tieupAssociativeArray)
        let maximumLambdaRuntimeSeconds = 300

        fetch(this.props.baseLambdaUri, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-api-key': this.props.apiKey
            },
            body: bodyText
        }).then((response) => {
            // call the results handler after converting the response JSON to a tieup grid array
            response.json().then((body) => {
                this.setStartTimeState(new Date())
                let secondsRemaining = Math.min(body.estimatedRuntimeSeconds, maximumLambdaRuntimeSeconds)
                if (secondsRemaining < 1) {
                    secondsRemaining = 1 // prevents divide by 0 on really short times when calculating percentages
                }
                this.setTotalRuntimeSeconds(secondsRemaining)
                this.timer = setInterval(() => {
                    this.loadResultsJSONTimerTick(body.s3ResultsJSONFilename, resultsHandler, updateProgressFunction)
                    // body.totalPossibleOptionsCount has total options
                    // body.estimatedRuntimeSeconds has estimated runtime seconds 
                }, 2000)
            })
        })
    }

    loadResultsJSONTimerTick(filename, resultsHandler, updateProgressFunction) {

        let fileUrl = this.props.baseS3Uri + '/' + filename
        let noResultsTimeoutInterval = 3 // time out if we go 3 seocnds past maximum Lambda runtime with no result

        fetch(fileUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }).then((response) => {
            // call the results handler after converting the response JSON to a tieup grid array
            if (response.ok) {
                clearInterval(this.timer)
                this.timer = null
                response.json().then((jsonPayload) => {
                    var skeletonTieupArray = this.createTieupArrayFromJSON(jsonPayload)
                    resultsHandler(skeletonTieupArray, jsonPayload.map)
                })
            }
            else {
                let elapsedSeconds = this.calculateElapsedRuntimeSeconds()
                let percentageComplete = this.calculatePercentageComplete(elapsedSeconds)

                if (elapsedSeconds > this.state.totalRuntimeSeconds + noResultsTimeoutInterval) {
                    clearInterval(this.timer)
                    this.timer = null
                    resultsHandler(null, null) // timeout; lambda failed or result unreachable
                }
                else {
                    updateProgressFunction(percentageComplete)
                }
            }
        }).catch((error) => {
            console.log('Fetch error: ' + JSON.stringify(error))
            let elapsedSeconds = this.calculateElapsedRuntimeSeconds()

            if (elapsedSeconds > this.state.totalRuntimeSeconds + noResultsTimeoutInterval) {
                console.log('http file load failed, ending timer')
                clearInterval(this.timer)
                this.timer = null
                resultsHandler(null, null) // timeout; lambda failed or result unreachable
            }
        })

    }


    createTieupArrayFromJSON(resultsAssociativeArray) {

        if (Object.getOwnPropertyNames(resultsAssociativeArray.tieup).length > 0) {

            let shaftsCount = this.props.tieupArray.length
            let treadlesCount = Object.getOwnPropertyNames(resultsAssociativeArray.tieup).length
            let tieupArray = new Array(shaftsCount)

            for (let i = 0; i < shaftsCount; i++) {
                let shaftTreadlesArray = new Array(treadlesCount)
                tieupArray[i] = shaftTreadlesArray
            }

            var treadleNumbers = []
            for (let treadleNumber in Object.keys(resultsAssociativeArray.tieup)) {
                if (resultsAssociativeArray.tieup.hasOwnProperty(treadleNumber)) {
                    treadleNumbers.push(parseInt(treadleNumber, 10));
                }
            }

            for (let treadleNumberValue = 0; treadleNumberValue < treadleNumbers.length; treadleNumberValue++) {
                let shaftAssignmentsArray = resultsAssociativeArray.tieup[treadleNumberValue]
                for (let i = 0; i < shaftAssignmentsArray.length; i++) {
                    let shaftNumber = parseInt(shaftAssignmentsArray[i], 10)
                    tieupArray[shaftNumber][treadleNumberValue] = true
                }
            }

            return tieupArray
        }
        else {
            return null
        }
    }

    createRequestJSON() {

        let sourceArray = this.props.tieupArray
        let shaftsCount = this.props.tieupArray.length
        let treadlesCount = this.props.tieupArray[0].length

        let tieupArray = {
            tieup: {},
            targetTreadlesCount: this.props.targetTreadlesCount
        }

        for (let t = 0; t < treadlesCount; t++) {
            let treadleAssignmentShafts = []
            for (let s = 0; s < shaftsCount; s++) {
                if (sourceArray[s][t]) {
                    treadleAssignmentShafts.push(s)
                }
            }
            tieupArray.tieup[t] = treadleAssignmentShafts
        }
        return tieupArray
    }

    searchForSkeletonTieup() {
        let requestJSON = this.createRequestJSON()
        let progressFunction = this.props.progressUpdateHandler
        progressFunction(0) // show progress immediately upon button click
        this.handleSkeletonSearch(requestJSON, this.props.resultsHandler, this.props.progressUpdateHandler)
    }


    render() {
        return <PrimaryButton onClick={(e) => { this.searchForSkeletonTieup(e) }}>Search for Skeleton Tieup</PrimaryButton>
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

}

export default SearchButton



// WEBPACK FOOTER //
// ./src/scenes/reducer/components/SearchButton/index.js